import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchUsers = (searchString, enabled = true) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        if (!enabled) {
            setUsers([]);
            setLoading(false);
            return undefined;
        }

        const fetchUsers = async () => {
            setLoading(true);
            const token = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_API_AUDIENCE,
                }
            });

            const response = await fetch(`${apiUrl}/api/users?searchString=${encodeURIComponent(searchString)}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setUsers(data);
            } else {
                console.error('Failed to fetch users');
            }
            setLoading(false);
        };

        fetchUsers();
    }, [searchString, getAccessTokenSilently, apiUrl, enabled]);

    return { users, loading };
};
